import { Flex, Tag, Tooltip } from "antd";
import * as React from "react";
import { WorkflowIcon } from "src/icons";

const workflowIconColor = "rgba(224, 157, 43, 1)";

type PropsWorkflowPageTitle = {
  title: string;
  stepName?: string;
  stepDescription?: string | null;
};

export const WorkflowPageTitle: React.FC<PropsWorkflowPageTitle> = ({
  title,
  stepName,
  stepDescription,
}) => (
  <Flex gap={16} align="center">
    <WorkflowIcon style={{ color: workflowIconColor }} />
    {title}
    {stepName ? (
      <Tooltip title={stepDescription || undefined}>
        <Tag color="gold">{stepName}</Tag>
      </Tooltip>
    ) : null}
  </Flex>
);
